export const contributions = {
  tax: "Due to BIR",
  gsis: "Due to GSIS",
  pagibig: "Due to Pagibig",
  phic: "Due to Philhealth",
};

export const payrollBreakdown = {
  salariesWages: "Salaries and Wages",
  pera: "Personal Economic Relief Allowance(PERA)",
  liabilities: "Trust Liabilities",
  officers: "Due to Officers and Employees",
  rata: "Representation Allowance/Transportation Allowance",
  midYear: "Mid Year Differential",
  yearEnd: "Year End Differential",
  gratuityPay: "Gratuity Pay",
};

export const contributionMap = {
  gsisLR: contributions.gsis,
  pagibig: contributions.pagibig,
  phic: contributions.phic,
};
